import Cookie from './Cookie';

$(document).ready(function () {
	let cookie = new Cookie('pop-up-seen');

	if (cookie.get() !== 'true') {
		window.scrollTo(0, 0);
		$('#popup-msg').modal('show');
	}

	$('.pop-up-button').on('click', function () {
		$('#popup-msg').modal('hide');
		cookie.set(true);
	});
});

$(document).ready(function () {
	let cookie = new Cookie('webshop_pop-up-seen');

	if (cookie.get() !== 'true') {
		window.scrollTo(0, 0);
		$('#webshop_popup-msg').modal('show');
	}

	$('.webshop-pop-up-button').on('click', function () {
		$('#webshop_popup-msg').modal('hide');
		cookie.set(true);
	});
});